<div
    class="h-100 w-100 m-0 bg-custom-primary d-flex flex-column align-items-center justify-content-center p-4 position-relative">
    <div class="logo position-absolute top-0 start-0 p-4">
        <img [src]="cvaUI_url + '/assets/images/logo.svg'" alt="logo" width="70px">
    </div>
    <div class="text-center">
        <h2 class="mb-2">Session Expired</h2>
        <p class="text-muted fs-6 mb-0">Please relaunch the Alex app to continue.</p>
    </div>
</div>